import { API_BASE_URL } from "@/config";
import { validate_form } from "@/utils/signio_validation.js";
import { allow_currency } from "@/utils/validations.js";


export default {
  name: "ApplicationIncome",
  emits: ["validity-change", "previous"],
  data() {
    const source_options = [
      "Salary",
      "Pension",
      "Investments",
      "Policy",
      "Retirement Annuity",
      "Donation/Gift",
      "Inheritance",
    ];
    const config = [
      {
        key: "sumIncomeCustomerGrossRemuneration",
        question: "Gross monthly remuneration (before deductions)",
        question_type: "number",
      },
      {
        key: "sumIncomeSpouseGrossRemuneration",
        question: "Spouse's gross monthly remuneration (before deductions)",
        question_type: "number",
      },
      {
        key: "sumIncomeCustomerMonthlyCommission",
        question: "Your monthly commission (Inc in Gross) ",
        question_type: "number",
      },
      {
        key: "sumIncomeSpouseMonthlyCommission",
        question: "Spouse's monthly commission (Inc in Gross)",
        question_type: "number",
      },
      {
        key: "sumIncomeCustomerCarAllowance",
        question: "Your car allowance? (Inc in Gross)",
        question_type: "number",
      },
      {
        key: "sumIncomeSpouseCarAllowance",
        question: "Spouse's car allowance (Inc in Gross)",
        question_type: "number",
      },
      {
        key: "sumIncomeCustomerOvertime",
        question: "Overtime income (Inc in Gross)",
        question_type: "number",
      },
      {
        key: "reimbursement",
        question: "Reimbursement (Inc in Gross)",
        question_type: "number",
      },
      {
        key: "addIncomeCustomerNetTakeHomePay",
        question: "Your net take-home pay (after deductions)",
        question_type: "number",
      },
      {
        key: "addIncomeSpouseNetTakeHomePay",
        question: "Spouse's net take-home pay (after deductions)",
        question_type: "number",
      },
      {
        key: "sumIncomeCustomerRental",
        question: "Your rental income",
        question_type: "number",
      },
      {
        key: "sumIncomeSpouseRental",
        question: "Spouse's rental income",
        question_type: "number",
      },
      {
        key: "sumIncomeCustomerMaintenance",
        question: "Your maintenance income",
        question_type: "number",
      },
      {
        key: "sumIncomeSpouseMaintenance",
        question: "Spouse's maintenance income",
        question_type: "number",
      },
      {
        key: "addIncomeCustomerOtherIncome",
        question: "Your other income",
        question_type: "number",
      },
      {
        key: "addIncomeSpouseOtherIncome",
        question: "Spouse's other income",
        question_type: "number",
      },
      {
        key: "addIncomeCustomerOtherIncomeDescription",
        question: "Description of your other income?",
        question_type: "text",
      },
      {
        key: "addIncomeSpouseOtherIncomeDescription",
        question: "Description of the spouse's other income?",
        question_type: "text",
      },
      {
        key: "customerTotalMonthlyIncome",
        question: "Total monthly income",
        question_type: "number",
      },
      {
        key: "spouseTotalMonthlyIncome",
        question: "Spouse's total monthly income",
        question_type: "number",
      },
    ];
    const customer_remuneration = [];
    const spouse_remuneration = [];
    const customer_other = [];
    const spouse_other = [];
    const customer_text = [];
    const spouse_text = [];
    const customer_totals = [];
    const spouse_totals = [];
    config.forEach((f) => {
      if (f.question_type === "number") {
        if (
          f.key.includes("Customer") &&
          [
            "sumIncomeCustomerGrossRemuneration",
            "sumIncomeCustomerMonthlyCommission",
            "sumIncomeCustomerCarAllowance",
            "sumIncomeCustomerOvertime",
            "reimbursement",
            "addIncomeCustomerNetTakeHomePay",
          ].includes(f.key)
        )
          customer_remuneration.push(f);
        else if (
          f.key.includes("Spouse") &&
          [
            "sumIncomeSpouseGrossRemuneration",
            "sumIncomeSpouseMonthlyCommission",
            "sumIncomeSpouseCarAllowance",
            "addIncomeSpouseNetTakeHomePay",
          ].includes(f.key)
        )
          spouse_remuneration.push(f);
        else if (
          f.key.includes("Customer") &&
          [
            "sumIncomeCustomerRental",
            "sumIncomeCustomerMaintenance",
            "addIncomeCustomerOtherIncome",
          ].includes(f.key)
        )
          customer_other.push(f);
        else if (
          f.key.includes("Spouse") &&
          [
            "sumIncomeSpouseRental",
            "sumIncomeSpouseMaintenance",
            "addIncomeSpouseOtherIncome",
          ].includes(f.key)
        )
          spouse_other.push(f);
        else if (["customerTotalMonthlyIncome"].includes(f.key))
          customer_totals.push(f);
        else if (["spouseTotalMonthlyIncome"].includes(f.key))
          spouse_totals.push(f);
      } else if (f.question_type === "text") {
        if (f.key.includes("Customer")) customer_text.push(f);
        else spouse_text.push(f);
      }
    });
    const form_data = { sourceOfIncome: "" };
    config.forEach((f) => {
      form_data[f.key] = f.question_type === "number" ? "" : "";
    });
    return {
      source_options,
      customer_remuneration,
      spouse_remuneration,
      customer_other,
      spouse_other,
      customer_text,
      spouse_text,
      customer_totals,
      spouse_totals,
      form_data,
      collapsed: { customer_income: false, spouse_income: false },
      is_married: false,
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    customer_total() {
      const keys = [
        'sumIncomeCustomerMonthlyCommission',
        'sumIncomeCustomerCarAllowance',
        'sumIncomeCustomerOvertime',
        'reimbursement',
        'addIncomeCustomerNetTakeHomePay',
        'sumIncomeCustomerRental',
        'sumIncomeCustomerMaintenance',
        'addIncomeCustomerOtherIncome'
      ];
      const total = keys.reduce((sum, key) => sum + (parseFloat(this.form_data[key]) || 0), 0);
      return total.toFixed(2);
    },
    spouse_total() {
      const keys = [
        'sumIncomeSpouseMonthlyCommission',
        'sumIncomeSpouseCarAllowance',
        'addIncomeSpouseNetTakeHomePay',
        'sumIncomeSpouseRental',
        'sumIncomeSpouseMaintenance',
        'addIncomeSpouseOtherIncome'
      ];
      const total = keys.reduce((sum, key) => sum + (parseFloat(this.form_data[key]) || 0), 0);
      return total.toFixed(2);
    },
    // Conditional computed properties for showing description fields
    show_customer_other_income_description() {
      const amount = parseFloat(this.form_data.addIncomeCustomerOtherIncome);
      return !isNaN(amount) && amount > 0;
    },
    show_spouse_other_income_description() {
      const amount = parseFloat(this.form_data.addIncomeSpouseOtherIncome);
      return !isNaN(amount) && amount > 0;
    },
  },
  watch: {
    // Clear description when other income amount becomes 0 or empty
    'form_data.addIncomeCustomerOtherIncome'(newVal) {
      const amount = parseFloat(newVal);
      if (isNaN(amount) || amount <= 0) {
        this.form_data.addIncomeCustomerOtherIncomeDescription = '';
      }
    },
    'form_data.addIncomeSpouseOtherIncome'(newVal) {
      const amount = parseFloat(newVal);
      if (isNaN(amount) || amount <= 0) {
        this.form_data.addIncomeSpouseOtherIncomeDescription = '';
      }
    },
  },
  methods: {
    allow_currency,
    validation_message_creation(message) {
      Swal.fire({
        title: "Field Validation Error",
        text: message,
        icon: "info",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    },
    validate_income_information() {
      // Reset validation styles
        $(`#sourceOfIncome`).removeClass('border-danger');
        $(`#sumIncomeCustomerGrossRemuneration`).parent().removeClass('border-danger');
        $(`#sumIncomeSpouseGrossRemuneration`).parent().removeClass('border-danger');
        $(`#addIncomeCustomerNetTakeHomePay`).parent().removeClass('border-danger');
        $(`#addIncomeSpouseNetTakeHomePay`).parent().removeClass('border-danger');
        $(`#addIncomeCustomerOtherIncome`).parent().removeClass('border-danger');
        $(`#addIncomeSpouseOtherIncome`).parent().removeClass('border-danger');
      
      // Validations for applicant income information
      if (!this.form_data.sourceOfIncome) {
        this.validation_message_creation("Please select a source of income.");
        $(`#sourceOfIncome`).addClass('border-danger');
        return false;
      }
      if(!this.form_data.sumIncomeCustomerGrossRemuneration) {
        this.validation_message_creation("Please enter your gross monthly remuneration.");
        $(`#sumIncomeCustomerGrossRemuneration`).parent().addClass('border-danger');
        return false;
      }
      if(!this.form_data.sumIncomeSpouseGrossRemuneration && this.is_married) {
        this.validation_message_creation("Please enter your spouse's gross monthly remuneration.");
        $(`#sumIncomeSpouseGrossRemuneration`).parent().addClass('border-danger');
        return false;
      }
      if(!this.form_data.addIncomeCustomerNetTakeHomePay) {
        this.validation_message_creation("Please enter your monthly net take-home pay.");
        $(`#addIncomeCustomerNetTakeHomePay`).parent().addClass('border-danger');
        return false;
      }
      if(!this.form_data.addIncomeSpouseNetTakeHomePay && this.is_married) {
        this.validation_message_creation("Please enter your spouse's monthly net take-home pay.");
        $(`#addIncomeSpouseNetTakeHomePay`).parent().addClass('border-danger');
        return false;
      }

      if (this.form_data.addIncomeCustomerOtherIncomeDescription && !this.form_data.addIncomeCustomerOtherIncome) {
        this.validation_message_creation("Please enter your other income amount.");
        $(`#addIncomeCustomerOtherIncome`).parent().addClass('border-danger');
        return false;
      }
      if (this.form_data.addIncomeSpouseOtherIncomeDescription && !this.form_data.addIncomeSpouseOtherIncome) {
        this.validation_message_creation("Please enter your spouse's other income amount.");
        $(`#addIncomeSpouseOtherIncome`).parent().addClass('border-danger');
        return false;
      }
      return true;
    },
    previous() {
      this.$emit("previous");
    },
    toggle(sec) {
      this.collapsed[sec] = !this.collapsed[sec];
    },
    on_amount_input(field) {
      this.form_data[field.key] = this.form_data[field.key].replace(/,/g, "");
    },
    format_amount(field) {
      let v = parseFloat(this.form_data[field.key]);
      this.form_data[field.key] = (isNaN(v) ? 0 : v).toFixed(2);
    },
    submit_section() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/sygnio_answer/`;

      this.form_data.customerTotalMonthlyIncome = this.customer_total;
      this.form_data.spouseTotalMonthlyIncome = this.spouse_total;

      if (!this.validate_income_information()) {
        return;
      }

      var errors = validate_form(this.form_data);
      if (errors.length > 0) {
        {
          const msg = errors
            .map(err => {
              return `${err.error}`
            })
            .join("\n")

          Swal.fire({
            title: "Validation Error",
            text: msg,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          })
        }
        return;
      }

      const answers = Object.keys(this.form_data).map((key) => ({
        answer: this.form_data[key],
        api_form_field: key,
      }));
      $.ajax({
        type: "POST",
        url: service_api,
        headers: { Authorization: `Token ${token}` },
        data: JSON.stringify({
          answers,
          workflow_id: this.workflow_id,
        }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              title: "Success",
              text: "Your information has been submitted successfully!",
              icon: "success",
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then(() => {
              this.$emit("validity-change", true)
            });
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to submit the information, try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
    fetch_sygnio_answers() {
      const token = localStorage.getItem('token');
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/get_sygnio_question_answers/`;
      
      $.ajax({
        type: 'POST',
        url: service_api,
        headers: {
          Authorization: `Token ${token}`
        },
        data: JSON.stringify({ workflow_id: this.workflow_id }),
        contentType: 'application/json',
        success: (response) => {
          if (response.status === 'success' && response.data) {
            const data = response.data;
            if (Array.isArray(data)) {
              data.forEach(item => {
                const key = item.api_form_field;
                const value = item.answer;
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
                if (key === 'customerMaritalStatus') {
                  this.is_married = (value === 'Married');
                }
              });
            } else if (typeof data === 'object') {
              Object.keys(data).forEach(key => {
                const value = data[key];
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
                if (key === 'customerMaritalStatus') {
                  this.is_married = (value === 'Married');
                }
              });
            }
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to fetch the answers, please try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        }
      });
    }
  },
  mounted(){
    this.fetch_sygnio_answers();
  }
};
